<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} điểm đến an toàn</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} điểm đến an toàn</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} điểm đến an toàn</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="8">
              <b-row>
                <b-col md="12">
                  <el-form-item label="Loại điểm đến" prop="ten_loai_diem_den">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.ten_loai_diem_den"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <el-form-item label="Tên điểm đến an toàn" prop>
                    <el-input
                      type="text"
                      v-model="mData.dataForm.thong_tin_chung.ten"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="4">
              <el-form-item class="mb-0" label="Ảnh đại diện">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit"
                  :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien"
                  :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien"
                  :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                  :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Giấy tờ
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseGiayTo
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseGiayTo" visible>
                  <b-row>
                    <b-col md="3">
                      <el-form-item label="Mã số thuế" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.giay_to.so_giay_to"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Nơi cấp" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.giay_to.noi_cap"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Ngày cấp" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.giay_to.ngay_cap"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>

                    <b-col md="3">
                      <el-form-item label="Địa chỉ" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.giay_to.dia_chi"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <!-- <b-col md="3">
              <el-form-item label="Mã ảnh scan" prop="">
                <el-input
                  type="text"
                  v-model="mData.dataFormOther.giay_to.scan"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
                    </b-col>-->
                    <b-col md="8">
                      <el-form-item
                        class="mb-0"
                        label="Ảnh giấy tờ scan"
                        prop
                        v-show="mData.viewMode != 'detail'"
                      >
                        <el-upload
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AnhGiayTo.limit"
                          :accept="mData.fileUploadOption.AnhGiayTo.accept"
                          :on-change="fn_uploadChangeAnhGiayTo"
                          :on-preview="fn_uploadPreviewAnhGiayTo"
                          :on-remove="fn_uploadRemoveAnhGiayTo"
                          :on-exceed="fn_uploadExceedAnhGiayTo"
                          multiple
                          :file-list="mData.fileUploadOption.AnhGiayTo.fileList"
                          :disabled="mData.viewMode == 'detail'"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                          :close-on-click-modal="true"
                          :visible.sync="mData.fileUploadOption.AnhGiayTo.dialogVisible"
                          width="60%"
                          top="51px"
                          title="Chi tiết"
                        >
                          <img
                            width="100%"
                            :src="mData.fileUploadOption.AnhGiayTo.dialogImageUrl"
                            alt
                          />
                        </el-dialog>
                      </el-form-item>
                      <el-form-item
                        class="mb-0"
                        label="Ảnh giấy tờ scan"
                        prop
                        v-show="mData.viewMode == 'detail'"
                      >
                        <div class="row">
                          <div
                            class="col-md-3 text-center"
                            v-for="item in mData.fileUploadOption.AnhGiayTo.fileList"
                            :key="item.name"
                          >
                            <el-image
                              style="width: 100px; height: 100px"
                              :src="item.url"
                              :preview-src-list="mData.dataDefault.listImageUrl"
                            >
                              <div slot="error" class="el-image__error">
                                <!-- <i class="el-icon-picture-outline"></i> -->
                                <span class="small" style="line-height:1rem;">{{item.name}}</span>
                              </div>
                            </el-image>
                            <el-button
                              @click="fn_download(item)"
                              type="info"
                              size="small"
                              plain
                            >Tải về</el-button>
                          </div>
                        </div>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Địa chỉ
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseDiaChi
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDiaChi" visible>
                  <b-row>
                    <b-col md="6">
                      <b-row>
                        <!-- <b-col md="6">
                          <el-form-item label="Quốc gia" prop>
                            <el-input
                              type="text"
                              v-model="mData.dataFormOther.dia_chi.quoc_gia"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                            ></el-input>
                          </el-form-item>
                        </b-col>-->
                        <!-- <b-col md="3">
                      <el-form-item label="Tỉnh" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.dia_chi.tinh"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>                     
                    <b-col md="3">
                      <el-form-item label="Huyện" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.dia_chi.huyen"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Xã" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.dia_chi.xa"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                        </b-col>-->

                        <!-- <b-col md="3">
                      <el-form-item label="Quốc gia" prop>
                        <el-select
                          v-model="mData.dataFormOther.dia_chi.quoc_tich_id"
                          :placeholder="aLang.c_select"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listCountry"
                            :key="item.id"
                            :label="item.ten.vi"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                        </b-col>-->
                        <b-col md="6">
                          <el-form-item label="Tỉnh/Thành phố" prop>
                            <el-select
                              v-model="mData.dataFormOther.dia_chi.tinh_id"
                              :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                              filterable
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listProvince"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item label="Quận/huyện" prop>
                            <el-select
                              v-model="mData.dataFormOther.dia_chi.huyen_id"
                              :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                              filterable
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listDistrict"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item label="Xã/Phường" prop>
                            <el-select
                              v-model="mData.dataFormOther.dia_chi.xa_id"
                              :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                              filterable
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listCommune"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item label="Địa chỉ" prop>
                            <el-input
                              type="text"
                              v-model="mData.dataFormOther.dia_chi.dia_chi"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                            ></el-input>
                          </el-form-item>
                        </b-col>
                        <!-- <b-col md="6">
                      <el-form-item label=" " prop>
                        <el-checkbox
                          v-model="mData.dataPropMapDiaDiem.showMap"
                          :disabled="mData.viewMode == 'detail'"
                        >Địa điểm trên bản đồ</el-checkbox>
                      </el-form-item>
                        </b-col>-->
                      </b-row>
                    </b-col>
                    <b-col md="6">
                      <b-row>
                        <b-col>
                          <!-- <map-component
                        :prop-data-map="mData.dataPropMapDiaDiem"
                        v-if="mData.dataPropMapDiaDiem.showMap"
                        :prop-disabled="mData.viewMode == 'detail'"
                          ></map-component>-->
                          <mapbox-component
                            @update="fn_getDataFromMapboxComponent"
                            :cordinatesValue="mData.mapDataObject.value"
                            v-if="mData.dataDefault.showMap"
                            id="mapBox"
                          ></mapbox-component>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Người đại diện
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseNguoiDaiDien
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseNguoiDaiDien" visible>
                  <b-row>
                    <b-col md="6">
                      <el-form-item label="Tên người đại diện" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.ho_ten"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Chức vụ" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.chuc_vu"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Ngày sinh" prop>
                        <el-date-picker
                          type="datetime"
                          v-model="mData.dataFormOther.nguoi_dai_dien.ngay_sinh"
                          :format="aElement.datepicker.formatDate"
                          :valueFormat="aElement.datepicker.valueFormat"
                          :disabled="mData.viewMode == 'detail'"
                          :placeholder="aElement.datepicker.placeholderDate"
                        >clearable</el-date-picker>
                      </el-form-item>
                    </b-col>

                    <b-col md="3">
                      <el-form-item label="Mã số thuế" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.so_giay_to"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Giới tính" prop>
                        <el-select
                          v-model="mData.dataFormOther.nguoi_dai_dien.gioi_tinh"
                          :placeholder="aLang.c_select"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listGioiTinh"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Điện thoại" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.dien_thoai"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Email" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.email"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item label="Địa chỉ" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.dia_chi"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Tiêu chí an toàn
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseTieuChi
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseTieuChi" visible>
                  <b-row>
                    <b-col md="12">
                      <el-checkbox-group v-model="mData.dataDefault.listTieuChiAnToan">
                        <el-checkbox
                          v-for="item in mData.dataDefault.listTieuChiAnToan"
                          :label="item"
                          :key="item"
                          disabled
                        >{{item}}</el-checkbox>
                      </el-checkbox-group>
                      <!-- <p v-for="item in mData.dataDefault.listTieuChiAnToan">{{ item }}</p> -->
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <!-- <el-button
              type="info"
              plain
              @click="fn_handle('update',mData.dataForm.id, mData.dataForm)"
              v-ladda
            >{{aLang.c_update}}</el-button>-->

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import DanhGiaDDATModel from "./DanhGiaDDATModel";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import MapComponent from "../../../component/MapComponent";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import CommuneApi from "../../../moduleApi/CommuneApi";
import MapboxComponent from "../../../component/MapboxComponent";

export default {
  components: {
    MapComponent,
    MapboxComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DanhGiaDDAT",
        urlImg: ExtensionService.urlSurveyImg,
        dataDefault: {
          roles: DataService.rolesInForm,
          listGioiTinh: DataService.gioiTinh,
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          listLoaiHinh: MethodService.copyObject(DataService.loaiHinhRegister),
          listTieuChiAnToan: [],
          listImageUrl: [],
          showMap: false
        },
        dataForm: MethodService.copyObject(DanhGiaDDATModel.dataForm),
        dataFormOther: MethodService.copyObject(
          DanhGiaDDATModel.dataFormOther
        ),
        validForm: DanhGiaDDATModel.validForm,
        validFormOther: DanhGiaDDATModel.validFormOther,

        fileUploadOption: {
          //MethodService.copyObject(DanhGiaDDATModel.dataFormOther.fileUploadOption),
          AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          },
          AnhGiayTo: {
            limit: null,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          }
        },
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem"
        },
        mapDataObject: {
          value: [107.9, 14.01667],
          geoJson: {
            type: "",
            coordinates: []
          }
        }
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await DiemDenAnToanApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await DiemDenAnToanApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.mData.fileUploadOption = MethodService.copyObject(
        DanhGiaDDATModel.dataFormOther.fileUploadOption
      );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await DiemDenAnToanApi.findById(id);
      // let resNew = MethodService.checkDifferentObject(
      //   MethodService.copyObject(DiemDenAnToanModel.dataForm),
      //   res.result
      // );
      // debugger;
      if (res.result) {
        let resGiayTo = [];
        let resDiaChi = [];
        let resNguoiDaiDien = [];
        let resForm = [];
        if (res.result.thong_tin_chung && res.result.thong_tin_chung.anh) {
          let data = {
            id: res.result.thong_tin_chung.anh,
            name: res.result.thong_tin_chung.anh,
            url: ExtensionService.urlSurveyImg + res.result.thong_tin_chung.anh
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }

        if (
          res.result.thong_tin_chung &&
          res.result.thong_tin_chung.giay_to &&
          res.result.thong_tin_chung.giay_to.scan
        ) {
          var data = [];
          var listImage = [];
          for (
            let i = 0;
            i < res.result.thong_tin_chung.giay_to.scan.length;
            i++
          ) {
            let item = {
              id: res.result.thong_tin_chung.giay_to.scan[i],
              name: res.result.thong_tin_chung.giay_to.scan[i],
              url:
                ExtensionService.urlSurveyImg +
                res.result.thong_tin_chung.giay_to.scan[i]
            };
            let url =
              ExtensionService.urlSurveyImg +
              res.result.thong_tin_chung.giay_to.scan[i];
            data.push(item);
            listImage.push(url);
          }

          this.mData.fileUploadOption.AnhGiayTo.fileList = data;
          this.mData.dataDefault.listImageUrl = listImage;
        }
        if (
          res.result.thong_tin_chung.giay_to &&
          res.result.thong_tin_chung.giay_to != null
        ) {
          resGiayTo = MethodService.checkDifferentObject(
            MethodService.copyObject(DanhGiaDDATModel.dataFormOther.giay_to),
            res.result.thong_tin_chung.giay_to
          );
        } else {
          resGiayTo = MethodService.copyObject(
            DanhGiaDDATModel.dataFormOther.giay_to
          );
        }
        if (
          res.result.du_lieu_khai_bao &&
          res.result.du_lieu_khai_bao.giay_to_ngay_cap
        ) {
          resGiayTo.ngay_cap = MethodService.formatDate(
            res.result.du_lieu_khai_bao.giay_to_ngay_cap,
            "date"
          );
        }

        this.mData.dataFormOther.giay_to = resGiayTo;

        if (
          res.result.thong_tin_chung &&
          res.result.thong_tin_chung.dia_chi &&
          res.result.thong_tin_chung.dia_chi.kinh_do &&
          res.result.thong_tin_chung.dia_chi.vi_do
        ) {
          this.mData.dataPropMapDiaDiem.lat =
            res.result.thong_tin_chung.dia_chi.vi_do;
          this.mData.dataPropMapDiaDiem.lng =
            res.result.thong_tin_chung.dia_chi.kinh_do;
          this.mData.dataPropMapDiaDiem.showMap = true;

          let coordinate = [
            res.result.thong_tin_chung.dia_chi.kinh_do,
            res.result.thong_tin_chung.dia_chi.vi_do
          ];
          this.mData.mapDataObject.value = coordinate;
          // console.log(coordinate);
          this.mData.mapDataObject.geoJson.type = "Point";
          this.mData.mapDataObject.geoJson.coordinates = coordinate;
          this.mData.dataDefault.showMap = true;
        }

        if (
          res.result.thong_tin_chung.dia_chi &&
          res.result.thong_tin_chung.dia_chi != null
        ) {
          resDiaChi = MethodService.checkDifferentObject(
            MethodService.copyObject(DanhGiaDDATModel.dataFormOther.dia_chi),
            res.result.thong_tin_chung.dia_chi
          );
        } else {
          resDiaChi = MethodService.copyObject(
            DanhGiaDDATModel.dataFormOther.giay_to
          );
        }

        this.mData.dataFormOther.dia_chi = resDiaChi;

        if (
          res.result.thong_tin_chung &&
          res.result.thong_tin_chung.dia_chi &&
          res.result.thong_tin_chung.dia_chi.tinh_id
        ) {
          let resProvince = await ProvinceApi.findById(
            res.result.thong_tin_chung.dia_chi.tinh_id
          );

          this.mData.dataDefault.listProvince.push(resProvince.result);
        }

        if (
          res.result.thong_tin_chung &&
          res.result.thong_tin_chung.dia_chi &&
          res.result.thong_tin_chung.dia_chi.huyen_id
        ) {
          let resDistrict = await DistrictApi.findById(
            res.result.thong_tin_chung.dia_chi.huyen_id
          );

          this.mData.dataDefault.listDistrict.push(resDistrict.result);
        }

        if (
          res.result.thong_tin_chung &&
          res.result.thong_tin_chung.dia_chi &&
          res.result.thong_tin_chung.dia_chi.xa_id
        ) {
          let resCommune = await CommuneApi.findById(
            res.result.thong_tin_chung.dia_chi.xa_id
          );

          this.mData.dataDefault.listCommune.push(resCommune.result);
        }

        if (
          res.result.thong_tin_chung.nguoi_dai_dien &&
          res.result.thong_tin_chung.nguoi_dai_dien != null
        ) {
          resNguoiDaiDien = MethodService.checkDifferentObject(
            MethodService.copyObject(
              DanhGiaDDATModel.dataFormOther.nguoi_dai_dien
            ),
            res.result.thong_tin_chung.nguoi_dai_dien
          );
        } else {
          resNguoiDaiDien = MethodService.copyObject(
            DanhGiaDDATModel.dataFormOther.giay_to
          );
        }

        this.mData.dataFormOther.nguoi_dai_dien = resNguoiDaiDien;

        if (
          res.result.thong_tin_chung.nguoi_dai_dien &&
          res.result.thong_tin_chung.nguoi_dai_dien != null
        ) {
          resForm = MethodService.checkDifferentObject(
            MethodService.copyObject(DanhGiaDDATModel.dataForm),
            res.result
          );
        } else {
          resForm = MethodService.copyObject(DanhGiaDDATModel.dataForm);
        }

        let tenLoai = this.mData.dataDefault.listLoaiHinh.find(
          element => element.code == resForm.loai_diem_den
        );
        if (tenLoai) {
          resForm.ten_loai_diem_den = tenLoai.text;
        } else {
          resForm.ten_loai_diem_den = "";
        }

        if (res.result.du_lieu_khai_bao) {
          let tieuChi1 = res.result.du_lieu_khai_bao.tieuchi1
            ? res.result.du_lieu_khai_bao.tieuchi1
            : null;
          let tieuChi2 = res.result.du_lieu_khai_bao.tieuchi2
            ? res.result.du_lieu_khai_bao.tieuchi2
            : null;
          let tieuChi3 = res.result.du_lieu_khai_bao.tieuchi3
            ? res.result.du_lieu_khai_bao.tieuchi3
            : null;
          let tieuChi4 = res.result.du_lieu_khai_bao.tieuchi4
            ? res.result.du_lieu_khai_bao.tieuchi4
            : null;
          let tieuChi5 = res.result.du_lieu_khai_bao.tieuchi5
            ? res.result.du_lieu_khai_bao.tieuchi5
            : null;
          // debugger;
          let arrTieuChi1 = tieuChi1 == null ? [] : tieuChi1.split("\n");
          let arrTieuChi2 = tieuChi2 == null ? [] : tieuChi2.split("\n");
          let arrTieuChi3 = tieuChi3 == null ? [] : tieuChi3.split("\n");
          let arrTieuChi4 = tieuChi4 == null ? [] : tieuChi4.split("\n");
          let arrTieuChi5 = tieuChi5 == null ? [] : tieuChi5.split("\n");

          let tieuChi = arrTieuChi1
            .concat(arrTieuChi2)
            .concat(arrTieuChi3)
            .concat(arrTieuChi4)
            .concat(arrTieuChi5);

          this.mData.dataDefault.listTieuChiAnToan = tieuChi;
        }

        this.mData.dataForm = resForm;
      }
    },
    async fn_initDataDefault() {},

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.thong_tin_chung.anh = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "anhDaiDien")
        .then(res => {
          this.mData.dataForm.thong_tin_chung.anh = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_uploadRemoveAnhGiayTo(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataForm.thong_tin_chung.giay_to.scan = data;
    },
    fn_uploadChangeAnhGiayTo(file, fileList) {
      ExtensionService.upload(file, "anhScan")
        .then(res => {
          this.mData.dataForm.thong_tin_chung.giay_to.scan.push(res.result);
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.AnhGiayTo.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhGiayTo(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhGiayTo.limit} file`
      );
    },
    fn_uploadPreviewAnhGiayTo(file) {
      this.mData.fileUploadOption.AnhGiayTo.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhGiayTo.dialogVisible = true;
    },

    fn_addLatLngDiaDiem(lat, lng) {
      this.mData.dataForm.thong_tin_chung.dia_chi.vi_do = lat;
      this.mData.dataForm.thong_tin_chung.dia_chi.kinh_do = lng;
    },

    fn_getDataFromMapboxComponent(value) {
      // debugger
      // console.log(value);
      this.mData.mapDataObject = value;
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_download(file) {
      // this.mData.fileUploadOption.FileDinhKem.dialogImageUrl = file.url;
      // this.mData.fileUploadOption.FileDinhKem.dialogVisible = true;

      window.open(ExtensionService.urlSurveyFile + file.id);
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>